import React, { useEffect, useRef, useCallback } from "react"
import { useLocation } from "react-router-dom"
import PropTypes from "prop-types"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"

//i18n
import { withTranslation } from "react-i18next"
import { useSelector } from "react-redux";

const SidebarContent = props => {
  const ref = useRef()
  const [isAdmin, setIsAdmin] = React.useState(false);

  const { roles } = useSelector(state => ({
    layoutType: state.Layout.layoutType,
    roles:
      state && state.Login && state.Login.userData && state.Login.userData.roles
        ? state.Login.userData.roles
        : null,
  }))

  React.useEffect(() => {
    if (roles && roles.toString().toLowerCase().includes("admin")) {
      setIsAdmin(true)
    } else {
      setIsAdmin(false)
    }
  }, [roles]);
    
  
  const { t } = useTranslation()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const path = useLocation()
  const activeMenu = useCallback(() => {
    const pathName = path.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName.includes(items[i].pathname)) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [path.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
    activeMenu()
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{t("common_overview")}</li>

            <li>
              <Link to="/dashboard">
                <i className="mdi mdi-view-dashboard-outline"></i>
                <span>{t("dashboard_dashboard")}</span>
              </Link>
            </li>
            {isAdmin && (
              <li>
                <Link to="/vendors">
                  <i
                    className="mdi mdi-account-multiple"></i>
                  <span>{t("vendors_vendors")}</span>
                </Link>
              </li>
            )}
            <li>
              <Link to="/revenue">
                <i className="bx bxs-down-arrow-square"></i>
                <span>{t("revenue_revenue")}</span>
              </Link>
            </li>
            <li>
              <Link to="/orders">
                <i className="bx bx-box"></i>
                <span>{t("orders_orders")}</span>
              </Link>
            </li>
            <li>
              <Link to="/coupons">
                <i className="bx bxs-coupon"></i>
                <span>{t("coupons_coupons")}</span>
              </Link>
            </li>
            <li>
              <Link to="/products">
                <i className="fas fa-boxes"></i>
                <span>{t("products_products")}</span>
              </Link>
            </li>
            <li>
              <Link to="/categories">
                <i className="fas fa-shapes"></i>
                <span>{t("categories_categories")}</span>
              </Link>
            </li>
            <li>
              <Link to="/delivery-men">
                <i className="fas fa-motorcycle"></i>
                <span>{t("deliveryMen_deliveryMen")}</span>
              </Link>
            </li>
            <li>
              <Link to="/customers">
                <i className="dripicons-user-group"></i>
                <span>{t("customers_customers")}</span>
              </Link>
            </li>
            <li>
              <Link to="/disputes">
                <i className="bx bx-user-voice"></i>
                <span>{t("disputes_disputes")}</span>
              </Link>
            </li>
            {/* <li>
              <Link to="/campaigns">
                <i className="mdi mdi-brightness-percent"></i>
                <span>{t("campaigns_campaigns")}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/offers">
                <i className="bx bx-badge"></i>
                <span>{t("offers_offers")}</span>
              </Link>
            </li> */}
            {/* <li>
              <Link to="/settings">
                <i className="bx bx-cog"></i>
                <span>{t("common_settings")}</span>
              </Link>
            </li> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
